<template xmlns="http://www.w3.org/1999/html">
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
                    <c-form-item type="input" label="标题" name="title"></c-form-item>
					<c-form-item type="checkbox" name="state" :options="stateArray"></c-form-item>
				</c-form>
			</m-search>

			<m-operate>
				<c-button  icon="add"  color="sys" @click="create()">添加</c-button>
			</m-operate>

            <c-table ref="table">
                <c-table-column
                        label="状态"
                        name="state"
                        width="80"
                >
                    <template v-slot="{data}">
                        <span v-if="data.state == 2" style="color:darkgreen;">启用</span>
                        <span v-if="data.state == 1" style="color:red;">禁用</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="推荐状态"
                        name="state"
                        width="90"
                >
                    <template v-slot="row">
                        <c-switch :value="row.data.extra_data_map && row.data.extra_data_map.recommend_state && row.data.extra_data_map.recommend_state == 2" text="推荐,不推荐"
                                  @change="changeRecommendState(row, arguments[0], arguments[1])"></c-switch>
                    </template>
                </c-table-column>

                <c-table-column
					label="标题"
					name="title"
					width="250"
				>
                </c-table-column>


                <c-table-column
                        label="荣誉证书"
                        name="image"
                >
                    <template v-slot="{data}">
                        <c-image :src="data.image" size="60"></c-image>
                    </template>
                </c-table-column>

                <c-table-column
                        label="创建时间"
                        name="create_date"
                        width="145"
                >
                </c-table-column>

				<c-table-column
					type="sort"
					label="排序"
					name="sort_id"
					@sort="sortHandle"
				>
				</c-table-column>

				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="200"
				>
					<template v-slot="{data}">
						<c-table-button  @click="edit(data)">编辑</c-table-button>
						<c-table-button  @click="del(data)">删除</c-table-button>
						<c-table-button  v-if="data.state == 1" @click="updateState(2, data)">{{'启用'}}</c-table-button>
						<c-table-button  v-if="data.state == 2" @click="updateState(1, data)">{{'禁用'}}</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>

		<c-dialog ref="editDialog" :title="editState ? '编辑企业荣誉' : '添加企业荣誉'" width="600" height="400" @resolve="submitForm">
			<c-form ref="editForm">
				<c-form-item type="hidden" name="id"></c-form-item>
				<c-form-item type="hidden" name="language_type"></c-form-item>
				<c-form-item type="hidden" name="recommend_state"></c-form-item>
                <c-form-item type="input" label="标题" name="title" required></c-form-item>
                <c-form-item type="image" label="荣誉证书" name="image" required file-word="建议尺寸：1500X2100"></c-form-item>
                <c-form-item type="textarea" label="备注" name="content"></c-form-item>
            </c-form>
		</c-dialog>
	</page>
</template>

<script>
export default {
	name: 'm_honor',

    props: {
        languageType: Number        //2=英文  1=中文
    },

	data() {
		return {
            currentTime:'',
			stateArray: [{
				name: '禁用',
				value: 1
			},{
				name: '启用',
				value: 2
			}],

			editState: false
		}
	},

	mounted() {
		this.$refs.search.search();
		this.getCurrentTime();
	},

	methods: {
        getCurrentTime() {
            //获取当前时间并打印
            let yy = new Date().getFullYear();
            let mm = new Date().getMonth()+1;
            let dd = new Date().getDate();
            let hh = new Date().getHours();
            let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
            let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
            this.currentTime = yy+'/'+mm+'/'+dd+' '+hh+':'+mf+':'+ss;
        },

		searchHandle(data) {
            data.language_type = this.languageType;
			this.$refs.table.load({
				url: '/website/honor/list',
				data
			});
		},

		sortHandle(row, type, next) {
			//row.prev() 上一行数据
			//row.next() 下一行数据
			let submitData ={};
			if(type=='top' || type=='bottom'){
				submitData.type = type;
				submitData.id = row.data.id;
			}
			if(type=='up'){
				submitData.id1 = row.data.id;
				submitData.id2 = row.prev().data.id;
			}
			if(type=='down'){
				submitData.id1 = row.data.id;
				submitData.id2 = row.next().data.id;
			}
			this.request({
				url: '/website/honor/sort',
				data: submitData,
				loading: true,
				success: data => {
					next();
				}
			});
		},

		create() {
            this.editState = false;
            this.$refs.editForm.clear();
            this.$refs.editForm.set({
                recommend_state:1,
                language_type:this.languageType,
                content:' ',
                type:1,
                publish_date:this.currentTime
            });
            this.$refs.editDialog.open();
		},

		edit(val) {
              this.editState = true;
              this.$refs.editForm.clear();
              this.request({
                  url: '/website/honor/detail',
                  data: {id:val.id},
                  loading: true,
                  success: data => {
                      data.recommend_state = data.recommend_state||1;
                      this.$refs.editForm.set(data);
                      this.$refs.editDialog.open();
                  }
              });
		},

		del(val) {
			this.$confirm({
				text: '确定要删除【'+val.title+'】吗？',  // 提示内容,
				buttonName: '确定',  // 确定按钮文字
				cancelButton: true,  // 是否显示取消按钮
				resolve: () => {
					this.request({
						url: '/website/honor/remove',
						data: {id:val.id},
						loading: true,
						success: data => {
							this.$message({
								text: '操作成功',
								icon: 'success'
							});
							this.$refs.table.update();
						}
					});
				},  // 确定按钮回调
				cancel: () => {},  // 取消按钮回调
			});
		},

		updateState(type,val) {
			this.$confirm({
				text: '确定要'+(type==2?'启用':'禁用')+'【'+val.title+'】吗？',  // 提示内容,
				buttonName: '确定',  // 确定按钮文字
				cancelButton: true,  // 是否显示取消按钮
				resolve: () => {
					this.request({
						url: '/website/honor/update_state',
						data: {id:val.id,state:type},
						loading: true,
						success: data => {
							this.$message({
								text: '操作成功',
								icon: 'success'
							});
							this.$refs.table.update();
						}
					});
				},  // 确定按钮回调
				cancel: () => {},  // 取消按钮回调
			});
		},

        /**
         * 推荐、取消
         * @param state true = 启用  false=禁用
         */
        changeRecommendState(item,state, stop) {
            stop();
            var params = item.data;
            var extra_data_map = {};
            extra_data_map.recommend_state = state?2:1;
            params.extra_data = '';
            params.extra_data_map = extra_data_map;
            this.request({
                url: '/website/honor/edit',
                data: params,
                loading: true,
                success: () => {
                    this.$message({
                        text: state ? '推荐成功' : '取消推荐成功'
                    });
                    this.$refs.table.update();
                },
                fail: (code, data, msg) => {
                    this.$confirm({
                        text: msg,  // 提示内容,
                        buttonName: '知道了',  // 确定按钮文字
                        cancelButton: false  // 是否显示取消按钮
                    });
                    return false;
                }
            });
        },

		submitForm(stop) {
			stop();
			let submitUrl = '/website/honor/add';
			if(this.editState){
				submitUrl = '/website/honor/edit';
			}
			this.$refs.editForm.submit({
				url: submitUrl,
				rule: {
					title: [{
						type: 'empty',
						word: '请填写标题'
					}],
					image: [{
						type: 'empty',
						word: '请上传荣誉证书'
					}]
				},
				dataFormatter: data => {
                    var extra_data_map = {};
                    extra_data_map.recommend_state = data.recommend_state;
                    data.language_type = this.languageType;
                    data.extra_data_map = extra_data_map;
                    return data;
				},
				success:(data,res) => {
					this.$message({
						text: '操作成功',
						icon: 'success'
					});
					this.$refs.table.update();
					this.$refs.editDialog.close();
				},
			});
		}
	}
}
</script>